import { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { SinglePlayer } from '../../../Api/Players/models';
import { checkPlayerExists, createPlayer } from '../../../Api/Players/Players';
import toast from 'react-hot-toast';
import Swal from 'sweetalert2';
import { useAdminInfo } from '../../../../../hooks/useAdminInfo';
import { Button as ButtonModel } from '../../../Api/Buttons/models';
import { fetchStaticButton } from '../../../Api/Buttons/Buttons';

interface EditPlayerModalProps {
    show: boolean;
    onHide: () => void;
    player: SinglePlayer | null;
}

export const CreateUserModal = ({ show, onHide, player }: EditPlayerModalProps) => {
    const { adminInfo } = useAdminInfo()
    const [loading, setLoading] = useState(false)

    const [messagesCreatePlayer, setMessagesCreatePlayer] = useState<ButtonModel>({
        id: '',
        name: '',
        category: '',
        createdAt: '',
        updatedAt: '',
        OwnerId: '',
        Messages: []
    })

    const [form, setForm] = useState<any>({
        firstName: player?.firstName || '',
        lastName: player?.lastName || '',
        email: player?.email || '',
        phone: player?.phone || '',
        platformUser: player?.platformUser || '',
        password: '',
    });

    const handleSubmit = async () => {
        if (loading) { return }
        if (!form.platformUser) {
            toast.error('Debe ingresar un usuario de la plataforma')
            return
        }

        // if (!form.email) {
        //     toast.error('Debe ingresar un email')
        //     return
        // }


        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (form.email && !emailRegex.test(form?.email)) {
            toast.error('Introduce un email válido');
            return false
        }

        // if (!form.phone) {
        //     toast.error('Debe ingresar un teléfono')
        //     return
        // }

        if (!form.password) {
            toast.error('Debe ingresar una contraseña')
            return
        }

        if (form.password.length < 6) {
            toast.error('La contraseña debe tener al menos 6 caracteres')
            return
        }

        const copyMessage = async (text: string) => {
            let updatedMessage = text
                .replaceAll('__USUARIO__', (form.platformUser))
                .replaceAll('__PASSWORD__', adminInfo?.default_users_password ?? 'hola123')
                .replaceAll('__LINK__', `${adminInfo?.pageLink}`)
                .replaceAll('__JUGADOR__', `${form.platformUser}`)
                .replaceAll('__EMAIL__', `${form.email ?? form.platformUser ?? ''}`)
                .replaceAll('__GESTORPASSWORD__', `${form.password}`)
                .replaceAll('__GESTORURL__', `${adminInfo?.gestorUrl}`)
            await navigator.clipboard.writeText(updatedMessage);
        }
        let randomIndex = Math.floor(Math.random() * messagesCreatePlayer?.Messages?.length);
        let randomValue = messagesCreatePlayer?.Messages[randomIndex];
        if (randomValue) copyMessage(randomValue.text)

        setLoading(true)

        const alreadyExists = await checkPlayerExists(form.platformUser)
        if (!alreadyExists?.success) {
            const errorMessage = alreadyExists?.response?.data?.msg ?? `Primero debes crear el usuario ${form.platformUser} en la plataforma de juegos y luego volver a intentarlo.`
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: errorMessage,
            })
            setLoading(false)
            return;
        }

        const res = await createPlayer(form)
        if (res?.success) {
            toast.success(`Jugador ${form.platformUser} creado correctamente`)
            toast.success(`Mensaje copiado al portapapeles`)
            onHide();
        } else {
            const errorMessage = res?.response?.data?.msg ?? 'Ha habido un error al crear el jugador'
            toast.error(errorMessage)
        }

        setLoading(false)
    };

    useEffect(() => {
        fetchStaticButton('static_newplayer').then((res) => {
            setMessagesCreatePlayer(res)
        })
    }, [])

    return (
        <>

            <Modal show={show} onHide={onHide} centered>
                <div className="border border-secondary rounded-3">
                    <Modal.Header closeButton>
                        <Modal.Title>Crear Jugador</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Form>
                            <Form.Group className="mb-3" controlId="formBasicCBU">
                                <Form.Label>Usuario de la plataforma</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el usuario de la plataforma" value={form.platformUser} onChange={(e) => setForm({ ...form, platformUser: e.target.value })} />
                                <Form.Text className="text-warning text-xs">
                                    Debe coincidir con el usuario de la plataforma de juegos ya creado.
                                    <br />
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicCBU">
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el nombre" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicAlias">
                                <Form.Label>Apellido</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el apellido" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicHourLimit">
                                <Form.Label>Teléfono</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el teléfono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicTitular">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicHourLimit">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese la contraseña" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                <Form.Text className="text-warning text-xs">
                                    * Esta contraseña es la que utilizará el jugador para entrar a su Gestor. <br />
                                    * La contraseña de la plataforma de juegos será {adminInfo?.default_users_password}
                                </Form.Text>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>
                            <Button variant="secondary" onClick={onHide}>
                                Cancelar
                            </Button>
                            <Button variant="primary" disabled={loading} onClick={handleSubmit}>
                                {loading ? 'Creando...' : 'Guardar'}
                            </Button>
                        </div>
                    </Modal.Footer>
                </div>
            </Modal>
        </>

    );
};
